import { useDispatch, useSelector } from 'react-redux';
import MasterLayout from '../components/layouts/MasterLayout';
import PageContentLayout from '../components/layouts/PageContentLayout';
import PageHeader from '../components/layouts/PageHeader';
import ProductList from '../components/products/ProductList';
import LoginForm from '../components/user/LoginForm';
import { useUser } from '../contexts/UserContext';
import FavoriteActiveTab from '../components/products/FavoriteActiveTab';
import MasterHeader from '../components/layouts/MasterHeader';
import MainSearch from '../components/search/MainSearch';
import { useEffect, useState } from 'react';
import { getFavoriteFiles } from '../redux/FavoriteFiles/action';
import { getFavoriteCollection } from '../redux/FavoriteCollection/action';
const FavoritesPage = () => {

    const [activeTab, setActiveTab] = useState("files");

    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const favoriteFiles = useSelector((state) => state.favoriteFiles.favoriteFilesData);
    const favoriteCollection = useSelector((state) => state.favoriteCollection.favoriteCollectionData);
    const { freeCheckbox } = state;
    const selectedId = state.selectItemDrawerMenu.selectedId;
    const { selectSpace } = state.selectSpace
    const { selectColor } = state.selectColor
    const { searchInputContent } = state.searchInputContent
    const { currentPage} = state.currentPage


    const { isLogin } = useUser();


    useEffect(() => {
        if (activeTab === "files") {
            dispatch(getFavoriteFiles());
        } else if (activeTab === "collections") {
            dispatch(getFavoriteCollection());
        }
    }, [activeTab, dispatch , freeCheckbox , selectedId , selectSpace , selectColor , searchInputContent , currentPage]);


    return (
        <MasterLayout>
            <MainSearch />
            <PageHeader title="FAVORITE ASSETS" />
            {isLogin ? (
                <ProductList
                    sectionTitle="FAVORITE ASSETS"
                    showMore={false}
                    loadMore={true}
                    showSort={true}
                    showCategory={true}
                />
            ) : (
                <>
                    <FavoriteActiveTab activeTab={activeTab} setActiveTab={setActiveTab} favoriteFiles={favoriteFiles} favoriteCollection={favoriteCollection}/>
                </>
            )}
        </MasterLayout>
    );
};

export default FavoritesPage;
